import { useEffect, useRef } from 'react'

const useDidMountEffect = (fn, deps) => {
  const didMount = useRef(false)

  useEffect(() => {
    if (didMount.current) {
      fn()
    } else {
      didMount.current = true
    }
  }, deps) // eslint-disable-line
}

export default useDidMountEffect
